import { render, staticRenderFns } from "./Picker.vue?vue&type=template&id=c87eb5f0&"
import script from "./Picker.vue?vue&type=script&lang=js&"
export * from "./Picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports